export default "__VITE_ASSET__CgtKk5Nq__";